<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UserInfoModal',
})
</script>
<template>
    <a-modal 
      :open="visible"  
      title="用户信息"
      width="600px"
      :bodyStyle="{ paddingBottom: '0' }"
      
      @update:open="handleOpenChange"  
    >
      <a-divider />
      
      <a-form
        :model="userInfo"  
        layout="horizontal"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 14 }"  
        style="margin-bottom: 16px;"
      >
        <a-form-item label="账号">
          <a-input 
            v-model:value="userInfo.empid" 
            readonly 
            :bordered="false"  
            class="underline-input" 
          />
        </a-form-item>
  
        <a-form-item label="姓名">
          <a-input 
            v-model:value="userInfo.name"   
            readonly 
            :bordered="false"  
            class="underline-input" 
          />
        </a-form-item>
  
        <a-form-item label="所属医院">
          <a-input 
            v-model:value="userInfo.hospital"   
            readonly 
            :bordered="false"  
            class="underline-input" 
          />
        </a-form-item>
  
        <a-form-item label="所属科室">
          <a-input 
            v-model:value="userInfo.deptName"   
            readonly 
            :bordered="false"  
            class="underline-input" 
          />
        </a-form-item>
      </a-form>
      
      <a-divider />
  
      <!-- 自定义底部按钮区 -->
      <template #footer>
          <div class="dialog-footer" >
            <a-button type="primary" @click="handleCancel">关闭</a-button>
          </div>
        </template>       

    </a-modal>
  </template>
  
  <script lang="ts" setup name="UserInfoModal">
  import { defineProps, defineEmits } from 'vue';
//   import { AForm, AFormItem, AInput, AButton, ADivider, AModal } from 'ant-design-vue';
  // 定义接收的属性
  const props = defineProps({
    visible: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      required: true,
      default: () => ({
        empid: '',
        name: '',
        hospital: '',
        deptName: ''
      })
    }
  });
  
  // 定义触发的事件
  const emit = defineEmits({
    'update:visible': (value: boolean) => true,
    cancel: () => true
  });
  
  // 处理弹窗自身状态变化（如点击遮罩层关闭）
  const handleOpenChange = (value: boolean) => {
    emit('update:visible', value);
  };
  
  // 处理关闭按钮点击
  const handleCancel = () => {
    emit('update:visible', false);
    emit('cancel');
  };
  </script>
  
  <style scoped lang="less">



  </style>